import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import GroupContent from '../pages/groups/content/GroupContent';
import CreateContent from '../pages/groups/content/CreateContent';
import EditContent from '../pages/groups/content/EditContent';

class ContentRoutes extends Component {
  render() {
    const { match } = this.props;
    sessionStorage.setItem('channelId', match.params.channelId);

    return (
      <div>
        <Switch>
          <Route
            exact
            path="/channel/:channelId/groups/:groupName"
            component={GroupContent}
          />
          <Route
            exact
            path="/channel/:channelId/groups/:groupName/create"
            component={CreateContent}
          />
          <Route
            exact
            path="/channel/:channelId/groups/:groupName/:contentId"
            component={EditContent}
          />
        </Switch>
      </div>
    );
  }
}

export default ContentRoutes;
